export default "__VITE_ASSET__hjYpyaNO__"